import {
	Badge,
	Card,
	CardBody,
	CardProps,
	Flex,
	Heading,
	Text,
} from "@chakra-ui/react";

interface TotalCardProps extends CardProps {
	title: string;
	value: number;
	percentageInLastMonth?: number;
}

export function TotalCard({
	title,
	value,
	percentageInLastMonth,
	...props
}: TotalCardProps) {
	const showPercentage = percentageInLastMonth !== undefined;

	function getPercentageText(percentage: number, digits: number = 2) {
		const value = percentage.toFixed(digits);
		if (percentage > 0) {
			return `+${value}%`;
		} else {
			return `-${value}%`;
		}
	}

	function getBadgeVariant(percentage: number) {
		if (percentage > 0) {
			return "green";
		} else {
			return "red";
		}
	}

	function getPercentageColor(percentage: number) {
		if (percentage > 0) {
			return "#45C14A";
		} else {
			return "#FF144D";
		}
	}

	function formatValue(value: number) {
		return value.toLocaleString("en-GB", {
			style: "currency",
			currency: "GBP",
		});
	}

	return (
		<Card {...props}>
			<CardBody>
				<Flex flexDirection="row" gap={2} alignItems="start">
					<Flex flexDirection="column" flex={1}>
						<Heading fontSize="23px" fontWeight="600" color="#302E34">
							{formatValue(value)}
						</Heading>
						<Text fontSize="14px" fontWeight="600" color="#302E34">
							{title}
						</Text>
						{percentageInLastMonth !== undefined && (
							<>
								<Flex alignItems="center" gap={1}>
									<Text
										fontSize="12px"
										fontWeight="600"
										color={getPercentageColor(percentageInLastMonth)}
									>
										{getPercentageText(percentageInLastMonth, 0)}
									</Text>
									<Text fontSize="12px" fontWeight="600" color="#B6B3B9">
										than last month
									</Text>
								</Flex>
							</>
						)}
					</Flex>
					{showPercentage && (
						<Badge variant={getBadgeVariant(percentageInLastMonth)}>
							{getPercentageText(percentageInLastMonth)}
						</Badge>
					)}
				</Flex>
			</CardBody>
		</Card>
	);
}
